// @ts-nocheck
import { BernieGraphqlClient, FetchPolicy, RequestOptions } from 'bernie-graphql';
import * as generated from './types';
import * as operations from './operations';

export interface OperationResult<T> {
  data: T;
  errors?: [];
  extensions: any;
  headers: Headers;
}

function isFetchPolicy(requestOptions: RequestOptions | FetchPolicy): requestOptions is FetchPolicy {
  return typeof requestOptions === 'string';
}

export class ApiOperations {
  public constructor(private client: BernieGraphqlClient) {
    //
  }

  public activityDestinationViewSearch(
    variables: generated.ActivityDestinationViewSearch.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.ActivityDestinationViewSearch.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.activityDestinationViewSearchQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then((result) => {
        const body = result.body;
        const data = body.data as generated.ActivityDestinationViewSearch.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public activityDetailOffers(
    variables: generated.ActivityDetailOffers.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.ActivityDetailOffers.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.activityDetailOffersQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then((result) => {
        const body = result.body;
        const data = body.data as generated.ActivityDetailOffers.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public activityDetailBasic(
    variables: generated.ActivityDetailBasic.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.ActivityDetailBasic.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.activityDetailBasicQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then((result) => {
        const body = result.body;
        const data = body.data as generated.ActivityDetailBasic.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public activityDetailOffer(
    variables: generated.ActivityDetailOffer.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.ActivityDetailOffer.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.activityDetailOfferQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then((result) => {
        const body = result.body;
        const data = body.data as generated.ActivityDetailOffer.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public activityDetailOffersWithAvailability(
    variables: generated.ActivityDetailOffersWithAvailability.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.ActivityDetailOffersWithAvailability.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.activityDetailOffersWithAvailabilityQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then((result) => {
        const body = result.body;
        const data = body.data as generated.ActivityDetailOffersWithAvailability.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public activityDetailReviews(
    variables: generated.ActivityDetailReviews.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.ActivityDetailReviews.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.activityDetailReviewsQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then((result) => {
        const body = result.body;
        const data = body.data as generated.ActivityDetailReviews.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public activityPageSeoContent(
    variables: generated.ActivityPageSeoContent.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.ActivityPageSeoContent.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.activityPageSeoContentQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then((result) => {
        const body = result.body;
        const data = body.data as generated.ActivityPageSeoContent.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public static withClient(client: BernieGraphqlClient) {
    return new ApiOperations(client);
  }
}
